import React from 'react';
import ThumbnailList from './ThumbnailList';
import GalleryContent from './GalleryContent';
import {
  GalleryContainer,
  ScrollThumbsDownButton,
  ScrollThumbsUpButton,
  ThumbnailListBackground
} from './Styles';
import DirectionalArrow from '../Icons/DirectionalArrow';
import styled from 'styled-components';

interface CarouselContainerProps {
  isDesktopHidden: boolean;
}

const CarouselContainer = styled.div<CarouselContainerProps>`
  position: relative;
  margin: 0 auto;
  display: block;
  background: linear-gradient(to bottom, #e5e5e5, #f7f7f7);
  @media (min-width: 992px) {
    display: ${({ isDesktopHidden }) => (isDesktopHidden ? 'none' : 'block')};
    padding: 2rem;
    margin-right: 2rem;
  }
`;

interface CarouselGalleryProps {
  mediaItems: any[];
  selectedMediaIndex: number;
  screenWidth?: number;
  showUpArrow: boolean;
  showDownArrow: boolean;
  siteId: string;
  selectedVariantData: any;
  videoIndex: number;
  isDesktopHidden: boolean;
  thumbnailListRef: React.RefObject<HTMLDivElement>;
  handleGalleryClick: () => void;
  handleThumbnailClick: (index: number) => void;
  handleGalleryScroll: (direction: 'left' | 'right') => void;
  handleThumbnailScroll: (direction: number) => void;
}

const CarouselGallery: React.FC<CarouselGalleryProps> = ({
  mediaItems,
  selectedMediaIndex,
  showUpArrow,
  showDownArrow,
  siteId,
  videoIndex,
  screenWidth,
  isDesktopHidden,
  thumbnailListRef,
  handleGalleryClick,
  handleThumbnailClick,
  handleGalleryScroll,
  handleThumbnailScroll,
}) => {

  return (
    <CarouselContainer isDesktopHidden={isDesktopHidden}>
      <GalleryContainer onClick={(e: { stopPropagation: () => void }) => e.stopPropagation()}>
        <ThumbnailListBackground />
        <ThumbnailList
          ref={thumbnailListRef}
          screenWidth={screenWidth}
          mediaItems={mediaItems}
          onThumbnailClick={handleThumbnailClick}
          videoThumbnail={mediaItems[videoIndex]?.thumbUrl || ''}
          activeIndex={selectedMediaIndex}
          mediaItemsLength={mediaItems.length}
        />
        <GalleryContent
          onGalleryScroll={handleGalleryScroll}
          mediaItems={mediaItems}
          videoThumbnail={mediaItems[videoIndex]?.thumbUrl}
          selectedImageIndex={selectedMediaIndex}
          toggleShowModal={handleGalleryClick}
          setSelectedIndex={handleThumbnailClick}
          videoIndex={videoIndex}
          siteId={siteId}
        />
        {showUpArrow && mediaItems.length > 5 && (
          <ScrollThumbsUpButton className="gallery-button" onClick={() => handleThumbnailScroll(-1)}>
            <DirectionalArrow direction="up" fill="#1A1B1B" strokeWidth={1.5} width="12" height="7" />
          </ScrollThumbsUpButton>
        )}
        {showDownArrow && mediaItems.length > 5 && (
          <ScrollThumbsDownButton className="gallery-button" onClick={() => handleThumbnailScroll(1)}>
            <DirectionalArrow direction="down" fill="#1A1B1B" strokeWidth={1.5} width="12" height="7" />
          </ScrollThumbsDownButton>
        )}
      </GalleryContainer>
    </CarouselContainer>
  );
};

export default CarouselGallery;
